<template>
    <div class="sold-detail-banner fashion" ref="banner">
        <!-- mobile top banner start -->
        <template v-if="isMobileSize">
            <div class="mobile-fixed-banner" v-sticky="{ class: 'fixed' }">
                <div class="button">
                    <div class="left-btn" @click="putAway">
                        <span
                            class="btn-putAway iconfont icon-boldarrow"
                        ></span>
                        <span class="btn-text">{{
                            $t('md-sold-detail.search')
                        }}</span>
                    </div>
                    <div class="right-btn">
                        <div class="item share" @click="sharePop">
                            <span class="iconfont icon-share-arrow"></span>
                        </div>
                    </div>
                </div>
                <Anchor />
            </div>
        </template>
        <!-- mobile top banner start -->
        <!-- pc top banner start -->
        <template v-else>
            <div
                class="pc-fixed-banner"
                :class="{ fixed: showFixedBanner }"
                :style="fixedBannerStyle"
            >
                <div class="banner-box mg-container">
                    
                    <div class="center mg-container">
                        <div class="price-address">
                            <price class="price"></price>
                            <!-- Est.price start -->
                            <span class="split"></span>
                            <est-price class="est-price" />
                            <!-- Est.price start -->
                            <!-- address start -->
                            <template
                                v-if="info.streetAddress || info.cityAddress"
                            >
                                <Addr tag="div" class="address" />
                            </template>
                            <!-- address end -->
                        </div>
                        <div class="save-share-tour">
                            <span class="item share">
                                <i class="iconfont icon-share-arrow"></i>
                                <span class="btn-text">{{
                                    $t('md-sold-detail.share')
                                }}</span>
                                <share-popper
                                    class="popper"
                                    :shares="shares"
                                    :theme="theme"
                                    :listingId="info.id"
                                ></share-popper>
                            </span>
                            <span class="item request" @click="request">{{
                                cmpRequestButtonText
                            }}</span>
                        </div>
                    </div>
                    
                </div>
            </div>
        </template>

        <!-- pc top fixed banner end -->
        <bread-crumb
            v-if="!isMobileSize "
            theme="fashion"
            :detailInfo="info"
        ></bread-crumb>

        <!-- pc top banner end -->
        <Swiper
            trackSource="detail-info-img"
            v-bind="options"
            class="swiper"
            @init="onSwiperReady"
            @slideChange="handleSlideChange"
        >
            <Slide
                v-for="(item, index) in allImages"
                :key="index"
                :class="`slide-pc slide-${item.length}`"
            >
                <div class="swiper-box" @click="touched(index, $event, item)">
                    <div class="swiper-video" v-if="item.type == '3d'">
                        <img-box
                            :src="item.preview"
                            :alt="videoImgAlt"
                        ></img-box>
                    </div>
                    <img-box
                        v-else
                        @load="onImgLoad(index, $event)"
                        :lazy="lazyload"
                        :src="item"
                        :alt="imgAlt"
                        class="swiper-img"
                    ></img-box>
                </div>
            </Slide>
            <div class="swiper-button-prev iconfont icon-prev disabled"></div>
            <div class="swiper-button-next iconfont icon-next"></div>
            <div
                class="image-count"
                v-if="allImages.length > 1"
                @click="touched(0)"
            >
                <span class="iconfont icon-pic"></span>
                {{ allImages.length }}
            </div>
        </Swiper>

        <PSwp
            :options="photoswipeOption"
            ref="pswp"
            defaultSize="1200x750"
            trackSource="detail-info-img"
        ></PSwp>
    </div>
</template>

<script>
import common from '../_mixins/banner';
import price from './price.vue';
import Addr from '../_components/address.vue';
import EstPrice from '../_components/est-price.vue';
import Anchor from '../_components/anchor.vue';
export default {
    mixins: [common],
    components: {
        price,
        Addr,
        EstPrice,
        Anchor
    },
    data: function() {
        return {
            slidesPerGroup: 1,
            speed: 1000,
            space: 2,
            theme: 'fashion',
            showFixedBanner: false
        };
    },
    computed: {
        slidesPerView() {
            return this.isMobileSize ? 1 : 3;
        }
    },
    methods: {
        onScroll() {
            let swiper = this.photoswipeOption.mySwiper;
            if (!swiper) {
                return; 
            }
            let rect = swiper.el.getBoundingClientRect();
            if (rect.top < 0) {
                this.showFixedBanner = true;
            } else {
                this.showFixedBanner = false;
            }
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.sold-detail-banner.fashion {
    // overflow: hidden;
    position: relative;
    .mls-provided.mg-container {
        line-height: 20px;
        font-size: 14px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 18px;
        color: #fff;
        z-index: 10;
        margin-left: 66px;
        &.margin {
            right: 40px;
        }
        @include media-600 {
            width: calc(100% - 120px);
            left: 0;
            transform: translateX(0);
            margin-left: 15px;
            bottom: 10px;
        }
    }
    .banner-schedule {
        cursor: initial;
        padding-top: 9px;
        visibility: hidden;
        width: 320px;
        position: absolute;
        right: 0;
        top: 100%;
        z-index: 3;
        font-family: var(--font-normal);
        text-align: left;
        // &>.table-schedule, &>tab-success{
        //     box-shadow: 0 5px 20px 0 rgba(170, 186, 218, 0.25);
        // }
    }
    .swiper {
        height: 400px;
        overflow: hidden;
        .swiper-button-prev,
        .swiper-button-next {
            position: absolute;
            bottom: 0;
            top: unset;
            z-index: 1;
            font-size: 35px;
            height: 100%;
            width: 100px;
            color: rgba(255, 255, 255, 0.6);
            opacity: 0.6;
            background-image: none;
            cursor: pointer;
            &:hover {
                background-size: 100%;
                background-image: linear-gradient(
                    90deg,
                    rgba(0, 0, 0, 0.6),
                    transparent
                );
                color: white;
            }
            &:after {
                display: none;
            }
            &::before {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            &.swiper-button-disabled {
                opacity: 0.35;
            }
        }
        .swiper-button-prev {
            left: 0;
        }
        .swiper-button-next {
            right: 0;
            &:hover {
                background-image: linear-gradient(
                    270deg,
                    rgba(0, 0, 0, 0.6),
                    transparent
                );
            }
        }
        .navigation-disabled {
            display: none;
        }
        .m-virtual-tour {
            display: block;
            position: absolute;
            right: 0;
            bottom: 0;
            padding: 15px;
            width: 48px;
            height: 48px;
            color: rgba(255, 255, 255, 0.8);
            font-size: 16px;
            z-index: 2;
            text-align: center;
            line-height: 20px;
        }
        .swiper-slide {
            height: 100%;
            width: 600px;
            display: flex;
        }
        .swiper-box {
            height: 100%;
            width: 100%;
            .swiper-img {
                width: 100%;
                height: 100%;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .swiper-video {
                height: 100%;
                position: relative;
                background: black;
                .play {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background: url('//static.chimeroi.com/site3/images/play.png');
                    background-size: cover;
                    height: 60px;
                    width: 60px;
                }
                .img-box {
                    height: 100%;
                }
            }
        }
        .image-count {
            display: none;
            position: absolute;
            bottom: 10px;
            right: 15px;
            padding: 7px 8px;
            background-color: rgba(74, 74, 96, 0.8);
            font-size: 14px;
            color: white;
            z-index: var(--level-low);
        }
    }
    .pc-fixed-banner .banner-box .center {
        .price-address {
            .price {
                display: inline-block;
                .first-price {
                    font-size: 20px;
                }
                .second-price {
                    font-size: 14px;
                }
            }
            .split {
                height: 12px;
                border: none;
                border-right: 1px solid rgba(255, 255, 255, 0.2);
                margin: 0 10px;
                display: inline-block;
            }
            .est-price {
                display: inline-block;
                vertical-align: text-bottom;

                .text {
                    position: relative;
                    color: #8195bd;
                    &:after {
                        content: '';
                        width: 100%;
                        height: 1px;
                        background-color: #8195bd;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                    }
                }
                .value {
                    margin-left: 8px;
                    color: #fff;
                }
            }
            .address {
                margin-top: 10px;
            }
        }
    }
}

@include media-600 {
    .sold-detail-banner.fashion {
        margin-top: 0;
        .swiper {
            height: 200px;
            .image-count {
                display: block;
            }
        }
    }
}

@mixin slideLeft() {
    width: 50%;
    flex: 1;
    height: 100%;
    margin-right: 2px;
}
</style>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.sold-detail-banner.fashion {
    // mobile top banner
    .mobile-fixed-banner {
        background-color: #242a3d;
        &.fixed {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 100;
        }
        .button {
            padding: 0 15px;
            height: 45px;
            background-color: #242a3d;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top: 1px solid rgba(255, 255, 255, 0.1);
        }

        .left-btn {
            color: #ffffff;
            .btn-putAway {
                transform: rotate(180deg);
                display: inline-block;
            }
            .iconfont {
                font-size: 18px;
            }
            .btn-text {
                margin-left: 3px;
                font-size: 18px;
            }
        }
        .right-btn {
            .item {
                margin-right: 20px;
                display: inline-block;
                &:last-of-type {
                    margin-right: 0;
                }
                &.share {
                    color: #adb9d1;
                }
                .iconfont {
                    font-size: 20px;
                }
            }
        }
    }
    // pc top banner
    .pc-fixed-banner {
        width: 100%;
        min-height: 80px;
        padding: 10px 0;
        background-color: #242a3d;
        position: fixed;
        top: 0;
        left: 0;
        z-index: var(--level-medium);
        opacity: 0;
        visibility: hidden;
        -webkit-transition: all 0.3s ease;
        -moz-transition: all 0.3s ease;
        -ms-transition: all 0.3s ease;
        -o-transition: all 0.3s ease;
        transition: all 0.3s ease;
        &.fixed {
            visibility: visible;
            opacity: 1;
        }
        .banner-box {
            margin: 0 auto;
            display: flex;
            justify-content: center;
            @media (min-width: 1210px) {
                &.mg-container {
                    width: auto;
                    max-width: none;
                    overflow: visible;
                }
                .center {
                    margin: 0;
                }
            }
            .left,
            .right {
                width: 80px;
                position: relative;
                .bg-img-box {
                    opacity: 0;
                    &:after {
                        content: '';
                        position: absolute;
                        width: 100%;
                        height: 60px;
                        top: 0;
                        left: 0;
                        background-color: rgba(0, 0, 0, 0.1);
                    }
                    .bg-img {
                        width: 80px;
                        height: 60px;
                        display: inline-block;
                    }
                }
                .btn {
                    color: #adb9d1;
                    position: absolute;
                    height: 25px;
                    width: 100%;
                    border-radius: 2px;
                    border: solid 1px #adb9d1;
                    text-align: center;
                    font-size: 14px;
                    font-family: var(--font-bold);
                    line-height: 23px;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 10;
                    display: block;
                    &:hover {
                        cursor: pointer;
                        border: none;
                        color: #ffffff;
                        line-height: 25px;
                        + .bg-img-box {
                            opacity: 1;
                        }
                    }
                    .iconfont {
                        font-size: 12px;
                        &.prev {
                            transform: rotate(180deg);
                            display: inline-block;
                        }
                    }
                }
            }
            .center {
                display: flex;
                justify-content: space-between;
                align-items: center;
                &.mg-container {
                    overflow: visible;
                    &:after {
                        content: none;
                    }
                    @media (max-width: 1209px) {
                        width: auto;
                        flex: 1;
                        margin: 0;
                    }
                }
                .address {
                    max-width: 600px;
                    @media (max-width: 1209px) {
                        max-width: 400px;
                    }
                    .street {
                        color: #ffffff;
                        font-size: 14px;
                        margin-right: 4px;
                    }
                    .city {
                        color: #8195bd;
                        font-size: 14px;
                    }
                }
                .save-share-tour {
                    .item {
                        cursor: pointer;
                        text-align: center;
                        color: #adb9d1;
                        display: inline-block;
                        height: 40px;
                        margin-right: 20px;
                        .btn-text {
                            font-size: 12px;
                            line-height: 2;
                        }
                        &:last-child {
                            margin-right: 0;
                        }
                        > .iconfont {
                            font-size: 18px;
                            display: block;
                        }
                        &.share {
                            position: relative;
                            &:hover {
                                color: #4476e5;
                                .popper {
                                    visibility: visible;
                                }
                            }
                            .popper {
                                position: absolute;
                                top: 100%;
                                left: 50%;
                                padding-top: 15px;
                                z-index: var(--level-medium);
                                transform: translateX(-50%);
                                visibility: hidden;
                            }
                        }
                        &.request {
                            position: relative;
                            vertical-align: top;
                            padding: 10px 18px;
                            border-radius: 2px;
                            font-size: 16px;
                            font-family: var(--font-bold);
                            max-width: 250px;
                            @include ellipsis();
                            @include color-button();
                        }
                    }
                }
            }
            .left {
                margin-right: 20px;
            }
            .right {
                margin-left: 20px;
            }
        }
    }
}
</style>
